<template>
	<div>
		<el-dialog title="固件升级" :visible.sync="Upgrade.dialogStatus" width="400px" :show-close="false" :close-on-click-modal="false">
			<div class="tip flexJA flexSb">
				<div v-if="Upgrade.progress != 100">下载中...</div>
				<div v-else>升级成功</div>
				<div class="progressText">{{Upgrade.progress}}%</div>
			</div>
			<div class="progress flexJA flexFs">
				<div :style="`width:${Upgrade.progress}%`"><img src="@/assets/images/38.png" /></div>
				<!-- <el-progress :percentage="Upgrade.progress" :show-text="false"></el-progress> -->
			</div>
			<div class="btns flexJA" v-if="Upgrade.progress == 100">
				<div class="btn flexJA btn-1" @click="confirm" v-if="Upgrade.progress == 100">确定</div>
				<!-- <div class="btn flexJA disabled" @click="confirm" v-else>取消</div> -->
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				num: 0,
				progress: 0,
				equipmentStatus1: true
			}
		},
		computed: {
			...mapState({
				update: (state) => state.update,
				UpdateTIme: (state) => state.UpdateTIme,
				Upgrade: (state) => state.Upgrade,
				equipmentStatus: (state) => state.equipmentStatus,
			}),
		},
		mounted() {
			if(this.Upgrade.progress == 0) {
				this.SetFilePath();
			}else {
				this.GetProgress();
			}
		},
		methods: {
			SetFilePath() {
				// const fileUrl = 'https://legion.jooneit.com/mvax/Y960_FW_V0.57.9.MVAX'; // 替换为实际文件URL
				// this.downloadFile(fileUrl, 'Y960_FW_V0.57.9.MVAX');
				
				// 1.读取指定路径下的更新文件，对固件进行升级
				let Timeout = true;
				console.log(`D:\\Downloads\\${this.update.versionCode}`)
				window.LZPlugin.nativeCall("IAPBurner.dll","SetFilePath", `D:\\Downloads\\${this.update.versionCode}`).then(res=>{
					console.log('IAPBurner.dll[SetFilePath]: ', res)
					if(res.msg == 'File Not find') {
						Timeout = false;
						this.$store.commit('setUpgrade', {status: false, progress: 0, dialogStatus: false});
						this.$message({ message: 'File Not find', type: 'warning' });
					}
				}).catch(err => {
					// this.$store.commit('setUpgrade', {status: false, progress: 0, dialogStatus: false});
					console.error('IAPBurner.dll[SetFilePath]: ', err)
				});
				setTimeout(()=>{
					if(Timeout) this.GetProgress();
				}, 1000)
			},
			GetProgress(e) {
				console.log(e)
				// 2.获取升级进度
				window.LZPlugin.nativeCall("IAPBurner.dll","GetProgress", null).then(res=>{
					console.log('IAPBurner.dll[GetProgress]: ', res)
					this.$store.commit('setUpgrade', {status: true, progress: Number(res.msg >= 100 ? 99 : res.msg) || 0});
					
					if(res.msg == 100 && this.Upgrade.status) {
						setTimeout(()=>{
							localStorage.removeItem('UpgradeData')
							this.$store.commit('setUpgrade', {progress: 100});
						}, (this.Upgrade.type == 3 ? 3000 : 10000));
					}else if(res.msg){
						console.log(this.Upgrade.type)
						if(this.Upgrade.type == 1) {
							if(this.progress == res.msg) {
								if(this.num > 10) {
									this.num = 0
									this.$store.commit('gotState', {key: 'equipmentShowStatus', data: true})
									this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: true});
									this.$store.commit('setUpgrade', {status: false, progress: 0, dialogStatus: false});
									return;
								}
								this.num = this.num + 1;
							}else {
								this.num = 0
								this.progress = res.msg
							}
						}
						this.progress = res.msg;
						localStorage.setItem('UpgradeData', this.Upgrade);
						// this.GetDeviceStatus();
						setTimeout(()=>{
							this.GetProgress();
						}, 1000);
					}
				}).catch(err => {
					console.error('IAPBurner.dll[GetProgress]: ', err)
				});
			},
			GetDeviceStatus() {
				window.LZPlugin.nativeCall("LenovoHeadset.dll","GetDeviceStatus",null).then(res=>{
					// console.log(res.msg)
					// this.$store.commit('setUpgrade', {pause: res.msg != "AT_DEVICE_LINKED"});
					this.$store.commit('gotState', {key: 'equipmentStatus', data: res.msg != "AT_DEVICE_LINKED"});
				}).catch(err=>{
					this.$store.commit('setUpgrade', {pause: true});
					this.$store.commit('gotState', {key: 'equipmentStatus', data: true})
				});
			},
			confirm() {
				localStorage.removeItem('UpgradeData');
				localStorage.removeItem('setUpgrade');
				this.$store.commit('gotState', {key: 'equipmentStatus', data: false})
				this.$store.commit('gotState', {key: 'equipmentShowStatus', data: false})
				this.$store.commit('setUpgrade', {status: false, progress: 0, dialogStatus: false, type: 0});
			},
			downloadFile(url, filename = 'downloaded_file') {
				fetch(url).then(response => {
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					console.log(response)
					return response.blob();
				}).then(blob => {
					console.log(blob)
					const a = document.createElement('a');
					const objectUrl = URL.createObjectURL(blob);
					console.log(objectUrl)
					a.href = objectUrl;
					a.download = filename;
					document.body.appendChild(a);
					a.click();
					// 清理
					setTimeout(() => {
						document.body.removeChild(a);
						URL.revokeObjectURL(objectUrl);
					}, 100);
				})
				.catch(error => {
					console.error('下载失败:', error);
					alert('文件下载失败: ' + error.message);
				});
			},
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/css/deep.scss';
	
	::v-deep .el-dialog {
		.tip {
			padding: 0 16px 15px;
			
			.progressText {
				color: rgba(234, 247, 255, 1);
			}
		}
		
		.progress {
			height: 9px;
			padding: 0 ;
			margin: 0 16px 32px;
			background: linear-gradient(180deg, #111417 0%, #1A1E24 100%);
			border: 0.5px solid rgba(57, 64, 77, 0.6975);
			
			div {
				height: 9px;
				position: relative;
				width: 100%;
				overflow: hidden;
				transition: all 0.2s linear;
				
				img {
					width: 361px;
					position: absolute;
					left: 2px;
					top: 50%;
					transform: translateY(-50%);
				}
			}
		}
	}
</style>